import { api } from '../index';

export const getTransportPrices = async (
  transportClassIds: number[],
  transportDistanceIds: number[],
) => {
  if (!transportClassIds.length || !transportDistanceIds.length)
    return [];

  const response = await api.get(`/transport/prices`, {
    params: { transportClassIds, transportDistanceIds },
  });

  return response?.data;
};

export const updateTransportPrice = async (data: {
  transportClassId: number;
  transportDistanceId: number;
  price: number;
}) => {
  const response = await api.put('/transport/prices', data);
  return response.data;
};
